// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"60":"bfafb32e","64":"8c624c76","74":"075a53f0","78":"0ff357cc","338":"221d4c54","486":"60bd0370","576":"fc560fcc","610":"37bfc2ef","642":"77ec7ee0","753":"d447e7af","775":"d4f5e8ec","865":"2cce9706","927":"fbdba534","990":"9cf35bdd"}[chunkId] + ".js";
};